<ng-container>
  <fieldset>
    <div class="form-group">
      <label class="label-above" for="internal-comment">{{ 'Comment' | translate }}</label>
      <p class="caption grey">{{ 'This comment is saved only in Nobinas internal system' | translate }}</p>
      <textarea 
        id="internal-comment" 
        formControlName="internalComment"
        [class.invalid]="(_parentForm.controls.internalComment.touched || _parentForm.controls.internalComment.dirty) && _parentForm.controls.internalComment.invalid">
      </textarea>

      @if (
        _parentForm.controls.internalComment.touched
        || _parentForm.controls.internalComment.dirty
      ) {
        <app-validation-message
          [control]="_parentForm.controls.internalComment">
        </app-validation-message>
      }
    </div>
  </fieldset>
</ng-container>
